<template>
  <div ref="formStep" class="form-step" data-step="4">
    <div class="herocontainer" ref="rocket">
      <div id="frame" ref="frame">
        <div class="rocket" >
          <div class="rocket__label" ref="labels">
            <p class="labels">3</p>
            <p class="labels">2</p>
            <p class="labels">1</p>
          </div>
        </div>
        <div class="heroimgwrapper heroimgwrapper1">
          <img ref="image1" src="@/assets/img/mann_jetpack_ohnefeuer.png"/>
        </div>
        <div class="heroimgwrapper heroimgwrapper2">
          <img ref="image2" src="@/assets/img/frau_jetpack_ohnefeuer.png"/>
        </div>
      </div>
    </div>
    <form @submit.prevent="runAnimation">
      <div ref="formContent" class="form-content">
        <div>
          <p>{{$t('formContent.Step5form_bubble1')}} <span class="editname">{{ localFormData.firstName }}</span>!
            {{$t('formContent.Step5form_bubble2')}}</p>
        </div>
      </div>
      <div
          ref="finishForm"
      >
      <button
          type="submit"

          class="button finishform"
      >
        <span>{{$t('formContent.Step5form_button')}}</span><img src="@/assets/img/arrow-right.svg"/>
      </button>
      </div>
    </form>
  </div>
</template>

<script>
import {gsap} from "gsap";
import { CustomEase } from "gsap/CustomEase";
gsap.registerPlugin(CustomEase);
/* eslint-disable */
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // Lokale Kopie der Prop-Daten
      localFormData: {},
    };
  },
  mounted() {
    // Erstellen einer lokalen Kopie der Prop-Daten
    this.localFormData = JSON.parse(JSON.stringify(this.formData));
    this.initView();
  },
  methods: {
    runAnimation() {
      let tl = gsap.timeline();
      const labels = this.$refs.labels.children;
      const rocket = this.$refs.rocket;
      const heroes = this.$refs.frame.querySelectorAll('.heroimgwrapper > img');

      let cdStart = 1.25, cdLeave = cdStart / 4,
          esDuration = 0.10, esRepeat = 20;

      tl.to(this.$refs.formContent, {autoAlpha: 0, yPercent: 40})
          .to(this.$refs.finishForm, {left: 200, autoAlpha: 0})
          .addLabel("countdown")
          .from(labels, {
            duration: cdStart,
            scale: 0,
            x: "50px", y: "50px",
            stagger: cdStart / labels.length,
            display:"block",
          }, "countdown")
          .to(labels, {
            duration: cdLeave,
            scale: 0,
            x: "20px", y: "20px",
            autoAlpha: 0,
            stagger: cdStart / labels.length,
          }, "countdown+=" + cdStart / labels.length)
          .addLabel("engine-start")
          .from(rocket, {
            duration: esDuration,
            x: "+=6px",
            repeat: esRepeat,
          }, "engine-start-=.5")
          .from(rocket, {
            duration: esDuration * 10,
            y: "+=9px",
          }, "engine-start-=.5")
          .addLabel("lift-off")
          .to(rocket, {
            duration: 1,
            y: "-=100px",
          }, "lift-off-=0.5")
          .addLabel("launch")
          .to(heroes, {
            duration: 1,
            y: () => "-=" + (document.body.offsetHeight - 400) + "px",
            stagger: -.1,
            ease: CustomEase.create("custom", "M0,0 C0,0 0.267,0.014 0.387,0.088 0.505,0.161 0.884,0.4 1,1 "),
          })
          .call(this.submitForm);
    },
    submitForm() {
      this.$emit('update', this.localFormData);
      this.$emit('next');
    },
    initView() {
      var splitTextTimeline = gsap.timeline();
      splitTextTimeline.to(this.$refs.formStep, {display: "flex", autoAlpha: 1});

      splitTextTimeline = gsap.timeline();
      splitTextTimeline.from(this.$refs.image1, {autoAlpha: 0, xPercent: 20});
      splitTextTimeline.from(this.$refs.image2, {autoAlpha: 0, xPercent: 40});
      splitTextTimeline.from(this.$refs.formContent, {autoAlpha: 0, yPercent: 40});
      splitTextTimeline.fromTo(this.$refs.finishForm, {left: 200, autoAlpha: 0}, {
        left: 0,
        autoAlpha: 1
      });
    }

  },
};
</script>


<style lang="scss">
//@import 'src/assets/css/components/multistepform';
</style>


